import { lazy } from "react";
import type { RouteObject } from "react-router";

const ConnectorsDashboard = lazy(() => import("./pages/page"));
const ConnectorsAdd = lazy(() => import("./pages/add/page"));
const ConnectorsWebhooks = lazy(() => import("./pages/webhooks/page"));
const ConnectorsSettings = lazy(() => import("./pages/settings/page"));
const McpTokens = lazy(() => import("./pages/mcp-tokens/page"));
const ConnectorDetail = lazy(() => import("./pages/[id]/page"));

export const connectorsRoutes: RouteObject[] = [
  { index: true, Component: ConnectorsDashboard },
  { path: "add", Component: ConnectorsAdd },
  { path: "webhooks", Component: ConnectorsWebhooks },
  { path: "mcp-tokens", Component: McpTokens },
  { path: "settings", Component: ConnectorsSettings },
  { path: ":id", Component: ConnectorDetail },
];
